import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import {
    TopologyVersion,
    useRestoreTopologyVersionMutation
} from '../../../../../app/apiSlice';
import { setToast } from '../../../../../app/appSlice';
import { useSecureApplication } from '../../../../../hooks/KeycloackConnection';
import { useState } from 'react';
import { setRestoredTopology } from '../../../editorSlice';
import { useTranslation } from 'react-i18next';

interface IRestoreVersion {
    version: TopologyVersion;
    onDone: () => any;
}

const RestoreVersion = ({version, onDone}: IRestoreVersion) => {

    const { hasAnyPerm } = useSecureApplication();
    const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);
    const [restoreVersion, restoreVersionStatus] = useRestoreTopologyVersionMutation();
    const dispatch = useDispatch();
    const {t: translate} = useTranslation();

    const footerDialog = () => {
        return (
            <>
                <Button
                    label={translate('button.cancel')}
                    onClick={() => setDialogVisibility(false)}
                    className="mr-3 p-button-outlined p-button-sm"
                />

                <Button
                    id="hook-form"
                    onClick={async () => {
                        try {
                            await restoreVersion({id: version.id, version: version.version}).unwrap();
                            dispatch(
                                setToast({
                                    title: translate('versions.restore'),
                                    severity: 'success',
                                    content: translate('versions.restore_done'),
                                    life: 3000,
                                })
                            );
                            dispatch(setRestoredTopology(version.id+version.version));
                            setDialogVisibility(false);
                            onDone();
                        } catch (e: any) {
                            dispatch(
                                setToast({
                                    title: translate('versions.restore'),
                                    severity: 'error',
                                    content: translate('versions.restore_fail'),
                                    life: 3000,
                                })
                            );
                        }
                    }}
                    type="submit"
                    label={translate('versions.restore')}
                    className="p-button-danger p-button-sm"
                >
                    {restoreVersionStatus.isLoading ? (
                        <FontAwesomeIcon className="ml-2" icon="spinner" spin/>
                    ) : null}
                </Button>
            </>
        );
    };

    return (
        <>
            <Dialog
                header={translate('versions.restore')}
                footer={footerDialog}
                visible={dialogVisibility}
                style={{width: '25vw'}}
                modal
                onHide={() => {
                    setDialogVisibility(false);
                }}
            >
                <div className="mb-3">
                    {translate('versions.restore_confirm')} {' '}
                    <span className="font-bold">{version.version}</span> ?
                </div>
            </Dialog>
            <Button
                className="p-button-text"
                icon="pi pi-spinner"
                title={translate('versions.restore')}
                disabled={!hasAnyPerm('pipelines.all', 'pipelines_del')}
                onClick={() => {
                    setDialogVisibility(true);
                }}
            ></Button>
        </>
    );
};

export default RestoreVersion;
